<template>
	<section>
		<el-col :span="5" >
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Offers</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Offers', params:{ active:'first' }})">{{offers.active}} active offers</el-link></p>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Offers', params:{ active:'second' }})">{{offers.proposed}} proposed offers</el-link></p>
				</div>
			</el-card>
		</el-col>
		<el-col :span="5" :offset="1">
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Inbound</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Inbound', params:{ active:'first' }})">{{inbound.inbound}} inbound items</el-link></p>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push({name:'Inbound', params:{ active:'second' }})">{{inbound.reported}} reported item</el-link></p>
				</div>
			</el-card>
		</el-col>
		<el-col :span="5" :offset="1">
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Outbound</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push('/outbound')">{{outbound.outbound}} outbound shipments</el-link></p>
				</div>
			</el-card>
		</el-col>
		<el-col :span="5" :offset="1">
			<el-card class="box-card" v-loading="loading">
				<div slot="header" class="clearfix">
					<span>Payments</span>
				</div>
				<div class="text item">
					<p><el-link type="primary" @click="$router.push('/payments')">{{balance.request}} payment request</el-link></p>
				</div>
			</el-card>
		</el-col>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import {getNurseHome} from "../../api/securityService";

	export default {
		created(){
			this.$on('changeDoctor',(value) => {
				setTimeout(()=>{
					this.getNurseHome();
				},300);
			});
		},
		data() {
			return {
				offers:{
					active:0,
					expired:0,
					proposed:0
				},
				inbound:{
					inbound:0,
					reported:0
				},
				outbound:{
					outbound:0
				},
				balance:{
					request:0
				},
				loading:false
			}
		},
		methods: {
			getNurseHome(){
				let param = {
					doctorNo:window.sessionStorage.getItem("currentCompany")
				}
				this.loading = true;
				getNurseHome(param).then((data)=>{
					this.loading = false;
					if(data.status===200){
						this.offers.active = data.result.activeOffer;
						this.offers.expired = data.result.expiredOffer;
						this.offers.proposed = data.result.proposedOffer;
						this.inbound.inbound = data.result.inboundItems;
						this.inbound.reported = data.result.reportItems;
						this.outbound.outbound = data.result.outBoundItems;
						this.balance.request = data.result.payment;
					}else{
						this.$message.error(data.message);
					}
				})
			}
		},
		mounted() {
			this.getNurseHome();
		}
	}

</script>


// WEBPACK FOOTER //
// overview.vue?ad40fa9c